import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, ChevronDownIcon, ShieldCheckIcon } from 'lucide-react';
const faqs = [['¿Necesito ser experta en Párkinson?', 'No. El sistema está pensado para cuidadoras y se centra en observación, comunicación y acompañamiento.'], ['¿Cuándo puedo empezar a aplicarlo?', 'Desde el primer día. Podés incorporar las herramientas mientras avanzás por el sistema.'], ['¿En qué situaciones puedo aplicar el sistema?', 'En situaciones cotidianas de cuidado donde aparece resistencia, como aseo, vestirse, prepararse para salir o colaborar en actividades.'], ['¿La garantía es real?', 'Sí. Tenés 14 días de garantía y podés solicitar la devolución dentro de ese período si el sistema no es para vos.'], ['¿Es 100% digital?', 'Sí. Recibís el PDF por email y podés usarlo desde celular, tablet o computadora, o imprimirlo.'], ['¿Garantiza que mi familiar acepte ayuda?', 'No. No podemos controlar cómo responderá tu familiar. El sistema te brinda herramientas para prepararte, comunicarte y acompañar con mayor claridad.']] as const;
const costs = ['Seguir llegando a cada situación sin un plan claro', 'Discusiones repetidas sobre lo mismo', 'Frustración acumulada día tras día', 'Culpa permanente después de cada conflicto', 'Relación deteriorada con tu familiar', 'Agotamiento emocional sin dirección'];
const purchases = [['Roxana M.', 'Buenos Aires'], ['Valeria S.', 'La Plata'], ['Daniela R.', 'Quilmes'], ['Silvia G.', 'San Isidro']];
export function GuaranteeAndFaq() {
  const [open, setOpen] = useState<number | null>(null);
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-21" data-mp="26sohl2elvr28">
        <div className="mx-auto max-w-3xl text-center" data-id="element-22" data-mp="21zviau1wpaxj">
          <ShieldCheckIcon className="mx-auto h-16 w-16 text-brand-light" aria-hidden="true" data-id="element-23" data-mp="21ybywukyejrj" />
          <h2 className="mt-5 font-display text-3xl font-bold sm:text-4xl" data-id="element-24" data-mp="1e8q0488hu6k2">
            GARANTÍA 14 DÍAS — SIN PREGUNTAS
          </h2>
          <div className="mt-8 rounded-2xl border-2 border-brand-green/40 p-7 sm:p-10" data-id="element-25" data-mp="1z0erwcnchala">
            <p className="text-slate-300" data-id="element-26" data-mp="2318ft60sepe6">
              Abrís los volúmenes. Aplicás el sistema.
            </p>
            <p className="mt-4 text-slate-300" data-id="element-27" data-mp="27rousuk9aj2n">
              Si en 14 días no es lo que esperabas, te devolvemos el 100%.
            </p>
            <p className="mt-5 font-display text-3xl font-bold text-brand-light sm:text-4xl" data-id="element-28" data-mp="2cqs0mh828tbo">
              Devolución del 100%
            </p>
            <p className="mt-2 text-lg font-bold" data-id="element-29" data-mp="1k2cmdwwr6f1e">sin formularios, sin drama.</p>
          </div>
          <p className="mt-5 text-sm text-slate-400" data-id="element-30" data-mp="1p1p98hnmjm3z">
            Tasa de devoluciones: menos del 1%.
          </p>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-31" data-mp="1u1le0j45bhkl">
        <div className="mx-auto max-w-3xl" data-id="element-32" data-mp="30h4e07m2ri9n">
          <h2 className="text-center font-display text-3xl font-bold sm:text-4xl" data-id="element-33" data-mp="30gcisxwe3mjw">
            PREGUNTAS FRECUENTES
          </h2>
          <div className="mt-10 space-y-3" data-id="element-34" data-mp="35hs6yytv696i">
            {faqs.map(([question, answer], index) => {
            const panelId = `faq-panel-${index}`;
            return <div key={question} className="overflow-hidden rounded-xl border border-white/10 bg-brand-dark" data-id="element-35" data-mp="outwnh9syksl" data-mpi={index}>
                  <button type="button" onClick={() => setOpen(open === index ? null : index)} aria-expanded={open === index} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 p-5 text-left font-bold sm:text-lg" data-id="element-36" data-mp="k17tcfpj3t9g">
                    <span data-id="element-37" data-mp="63ash741l0oz">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-light transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-38" data-mp="62816y2t4w8j" />
                  </button>
                  <AnimatePresence initial={false} data-id="element-39" data-mp="3sc2c5uh258k5">
                    {open === index && <motion.div id={panelId} initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.22,
                  ease: [0.23, 1, 0.32, 1]
                }} data-id="element-40" data-mp="1vgwhhaeiqybu">
                        <p className="border-t border-white/10 px-5 py-5 leading-relaxed text-slate-300" data-id="element-41" data-mp="1ol4nym36dzi0">
                          {answer}
                        </p>
                      </motion.div>}
                  </AnimatePresence>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}
export function CostSection() {
  return <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-42" data-mp="15voa6x2hcajn">
      <div className="mx-auto max-w-4xl" data-id="element-43" data-mp="15t22mxfl9v1f">
        <h2 className="text-center font-display text-3xl font-bold text-brand-gold sm:text-4xl" data-id="element-44" data-mp="1at6o71vctfyi">
          ⚖️ ¿CUÁNTO CUESTA NO TENER EL SISTEMA?
        </h2>
        <div className="mt-10 overflow-hidden rounded-2xl border border-[#1a4a2e]" data-id="element-45" data-mp="wwksnxiyo379">
          {costs.map(item => <p key={item} className="border-b border-l-4 border-[#1a4a2e] border-l-[#2d6b45] bg-[#0d2f1e] px-5 py-4 font-medium last:border-b-0" data-id="element-46" data-mp="i7hz9q5rmjuw">
              <span className="mr-2 text-red-400" aria-hidden="true" data-id="element-47" data-mp="d9gen0soychb">
                ×
              </span>
              {item}
            </p>)}
        </div>
        
        
      </div>
    </section>;
}
export function FooterAndProofPopup() {
  const [purchase, setPurchase] = useState(0);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const timer = window.setInterval(() => {
      setPurchase(value => (value + 1) % purchases.length);
      setVisible(true);
      window.setTimeout(() => setVisible(false), 5000);
    }, 40000);
    return () => window.clearInterval(timer);
  }, []);
  return <>
      <footer className="border-t border-white/10 bg-brand-ink px-4 py-12 text-center" data-id="element-48" data-mp="15xvqxfkfugoy">
        <span className="inline-block rounded-full border border-brand-green/25 bg-brand-green/10 px-3 py-1 text-sm font-semibold text-brand-light" data-id="element-49" data-mp="1jxdejrlzznwq">
          🎯 SISTEMA COOPERACIÓN SIN CONFLICTOS™
        </span>
        <p className="mx-auto mt-4 max-w-md font-semibold text-slate-300" data-id="element-50" data-mp="ci9mzdnpejqx">
          Protocolo de comunicación para cuidadoras de familiares con Párkinson.
        </p>
        <p className="mx-auto mt-2 max-w-md text-sm italic text-slate-500" data-id="element-51" data-mp="lk94s86jlrux">
          “No podés elegir su respuesta, pero sí cómo prepararte.”
        </p>
        <div className="mt-7 flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-slate-400" data-id="element-52" data-mp="vau8ub4zjol8">
          <a className="hover:text-brand-light" href="mailto:soportebiomalivido@gmail.com" data-id="element-53" data-mp="109osffas1h6e">
            📧 soportebiomalivido@gmail.com
          </a>
          <span data-id="element-54" data-mp="14c1xs2lm3d2n">📲 @biomalivido</span>
          <a className="hover:text-brand-light" href="https://biomalivido.com" target="_blank" rel="noreferrer" data-id="element-55" data-mp="19amys48ou0s5">
            🌐 biomalivido.com
          </a>
        </div>
        <p className="mt-8 text-xs text-slate-600" data-id="element-56" data-mp="364q4wn1dmknp">
          © SISTEMA COOPERACIÓN SIN CONFLICTOS™ 2026 — Todos los derechos
          reservados.
        </p>
      </footer>

      <AnimatePresence data-id="element-57" data-mp="33jilzzsmlnk5">
        {visible && <motion.aside initial={{
        x: -30,
        opacity: 0
      }} animate={{
        x: 0,
        opacity: 1
      }} exit={{
        x: -30,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="fixed bottom-5 left-5 z-50 max-w-[285px] rounded-xl border border-brand-green/30 bg-brand-ink p-4 shadow-2xl" aria-live="polite" data-id="element-58" data-mp="33kk1qhkl6y87">
            <p className="flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-brand-light" data-id="element-59" data-mp="3mez2abmjqyy5">
              <CheckCircle2Icon className="h-4 w-4" aria-hidden="true" data-id="element-60" data-mp="3cj5ic76i036c" />
              Compra verificada
            </p>
            <p className="mt-2 text-sm font-semibold" data-id="element-61" data-mp="38ibrp61o8a9r">
              {purchases[purchase][0]} de {purchases[purchase][1]}
            </p>
            <p className="text-sm text-slate-300" data-id="element-62" data-mp="215jow9tlvff0">
              compró Sistema Cooperación Sin Conflictos™
            </p>
            <p className="mt-1 text-xs text-slate-500" data-id="element-63" data-mp="1x4rgtjwgzgkb">hace unos minutos</p>
          </motion.aside>}
      </AnimatePresence>
    </>;
}